import { render, staticRenderFns } from "./ChangeViewBanner.vue?vue&type=template&id=679c82fe&"
import script from "./ChangeViewBanner.vue?vue&type=script&lang=js&"
export * from "./ChangeViewBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports